import { render, staticRenderFns } from "./lecturer.vue?vue&type=template&id=8899b456"
import script from "./lecturer.vue?vue&type=script&lang=js"
export * from "./lecturer.vue?vue&type=script&lang=js"
import style0 from "./lecturer.vue?vue&type=style&index=0&id=8899b456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports